// extracted by mini-css-extract-plugin
export default {"container":"SPCheckbox_container__0Q5BC","checkmark":"SPCheckbox_checkmark__ODcG+"};